// Cuánto le queda al apartado de la venta (REQ-149); se refresca cada 15 s.
// Vencido, ofrece volver a elegir el teléfono si hay a dónde.
import { useEffect, useState } from 'react';
import { Button } from '@/kit';
import { PHONE_WARNING_MINUTES } from '../phoneReservation';
import { isReservationLive, reservationMinutesLeft } from '../reservationClock';

const TICK_MS = 15_000;

export function ReservationClock({
    expiresAt,
    firstToExpireName,
    phoneExpiresAt,
    onReselect,
}: {
    expiresAt: string | undefined;
    /** Nombre de la línea que vence primero cuando no es la ancla. */
    firstToExpireName?: string;
    /** Vencimiento del teléfono; a pocos minutos se avisa aunque venza primero otra línea. */
    phoneExpiresAt?: string;
    onReselect?: () => void;
}) {
    const [now, setNow] = useState(() => Date.now());
    useEffect(() => {
        const id = setInterval(() => {
            setNow(Date.now());
        }, TICK_MS);
        return () => {
            clearInterval(id);
        };
    }, []);

    if (!isReservationLive(expiresAt, now)) {
        return (
            <span className="flex flex-wrap items-center gap-2">
                <span className="text-destructive">El apartado venció</span>
                {onReselect !== undefined && (
                    <Button size="sm" variant="outline" onClick={onReselect}>
                        Vuelve a elegir el teléfono
                    </Button>
                )}
            </span>
        );
    }
    const minutes = reservationMinutesLeft(expiresAt, now);
    if (minutes === null) return null;
    const suffix = firstToExpireName !== undefined ? ` (vence primero: ${firstToExpireName})` : '';
    const phoneMinutes =
        firstToExpireName === undefined ? minutes : reservationMinutesLeft(phoneExpiresAt, now);
    const phoneSoon = phoneMinutes !== null && phoneMinutes <= PHONE_WARNING_MINUTES;
    return (
        <span>
            {`Quedan ${String(minutes)} min${suffix}`}
            {phoneSoon && (
                <span role="status" className="ml-1 font-semibold text-warning">
                    {`· El teléfono vence en ${String(phoneMinutes)} min.`}
                </span>
            )}
        </span>
    );
}
